module.exports = {
  VERSION: '',
  createDashboard: require('./api/create-dashboard')
};
